import { render, staticRenderFns } from "./AtualizacaoContato.vue?vue&type=template&id=c6ebf2b6&"
import script from "./AtualizacaoContato.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports